import { render, staticRenderFns } from "./AcoesCobrancas.vue?vue&type=template&id=782f2395"
import script from "./AcoesCobrancas.vue?vue&type=script&lang=js"
export * from "./AcoesCobrancas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports